import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GoogleLoginProvider, SocialAuthService } from 'angularx-social-login';
import { CryptPasswordService } from 'app/shared/services/crypt-password/crypt-password.service';
import { DataService } from 'app/shared/services/data/data.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { UserService } from 'app/shared/services/user/user.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';
import { LoginComponent } from '../login/login.component';

declare const invokeCSharpAction: any;

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent extends SubscriptionBaseComponent implements OnInit {

  checked = false;
  registerForm: FormGroup;
  loading = false;

  inactive = false;

  date = new Date();

  socialLastname: string;
  socialFirstname: string;
  socialEmail: string;
  userSocialInfo: object;

  resultMessage: string;


  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private userService: UserService,
    private dataService: DataService,
    private cryptPasswordService: CryptPasswordService,
    private uiService: UiService,
    private cdr: ChangeDetectorRef,
    private authService: SocialAuthService,
    private loginComponent: LoginComponent

  ) {
    super();
  }

  ngOnInit(): void {
    this.initForm();
    this.initSub();
  }

  onSubmit(): void {

    if (this.registerForm.invalid) {
      this.errorsToManage();
      this.inactive = true;
      return;
    }

    this.loading = true;

    const checkPassword = this.registerForm.get('password').value === this.registerForm.get('confirmPassword').value;
    const passwordToSend = this.cryptPasswordService.cryptPassword(this.registerForm.get('password').value);
    const userInfos = JSON.parse(JSON.stringify(this.userSocialInfo));

    const newUser = {
      firstName: this.registerForm.get('firstName').value,
      lastName: this.registerForm.get('lastName').value,
      dBirth: this.date,
      email: this.registerForm.get('email').value,
      name: null,
      titre: null,
      monClub: null,
      password: passwordToSend,
      socialId: null,
      json: null,
      socialType: null
    };

    checkPassword ? this.getRegisterForm(newUser) : this.ifCheckPasswordIsOk();
    this.dataService.email.next(this.registerForm.get('email').value);
  }

  conditonNotAccepted(): void {
    this.uiService.openSnackBar('Vous devez accepter les conditions d\'utilisations', '');
  }

  isCheck(): void {
    this.checked = !this.checked;
  }

  isInactive(inputValue: string): void {
    inputValue ? this.inactive = true : this.inactive = false;
  }

  private ifCheckPasswordIsOk(): void {
    this.uiService.openSnackBar(`La confirmation du mot de passe n'est pas valide`, '');
    this.inactive = false;
    this.loading = false;
    this.registerForm.reset({
      title: this.f.title.value,
      lastName: this.f.lastName.value,
      firstName: this.f.firstName.value,
      email: this.f.email.value,
      password: this.f.password.value,
      confirmPassword: '',
    });
  }

  private getRegisterForm(newUser): void {
    const email = newUser.email.split('@')[1].split('.')[0];

    // email === 'google' ?
    //   console.log('connexion via goole') :
    //   console.log('inscription');

    // this.inactive = false;

    email === 'gmail' ?
      this.loginWithSocialMediaGoogle() :
      (this.userService.registerUser(newUser).subscribe(() => {
        this.router.navigate(['/confirm-register']);
      }, error => {
        // this.uiService.openSnackBar(error.error, '');
      }));
  }

  loginWithSocialMediaGoogle(): void {
    this.uiService.openSnackBar(`Vous allez être redirigé pour être connecté via Google`, '');

    const platform = GoogleLoginProvider.PROVIDER_ID;
    const platformType = platform.toLocaleLowerCase();
    this.authService.signIn(platform).then(
      (response) => {
        this.loginComponent.socialLogin(response, platform);
      },
      (error) => {
        this.resultMessage = error;
      });
    invokeCSharpAction(platform.toLowerCase());
  }


  private errorsToManage(): void {
    const lastName = this.f.lastName.errors?.required;
    const firstName = this.f.firstName.errors?.required;
    const email = this.f.email.errors?.required;
    const emailError = this.f.email.errors?.email;
    const password = this.f.password.errors?.required;
    const confirmPassword = this.f.confirmPassword.errors?.required;
    const check = lastName && firstName && email && password && confirmPassword;

    if (check) {
      this.uiService.openSnackBar(`Les champs sont vides`, '');
    } else {

      if (lastName) { this.uiService.openSnackBar(`Champ Nom requis`, ''); }
      if (firstName) { this.uiService.openSnackBar(`Champ Prénom requis`, ''); }
      if (email) {
        this.uiService.openSnackBar(`Champ email requis`, '');
        this.registerForm.reset({
          title: this.f.title.value,
          lastName: this.f.lastName.value,
          firstName: this.f.firstName.value,
          email: '',
          licence: this.f.licence.value,
          password: this.f.password.value,
          confirmPassword: '',
        });
      }
      if (password) { this.uiService.openSnackBar(`Mot de passe requis`, ''); }
      if (this.f.password.errors?.pattern) { this.uiService.openSnackBar('Le mot de passe ne contient pas au minimum huit caractères, au moins une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial', ''); }
      if (confirmPassword) { this.uiService.openSnackBar(`Confirmez votre mot de passe`, ''); }
      if (this.f.confirmPassword.errors?.pattern) { this.uiService.openSnackBar('Le mot de passe ne contient pas au minimum huit caractères, au moins une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial', ''); }

      if (emailError) {
        this.uiService.openSnackBar(`Le mail n'est pas valide`, '');
        this.registerForm.reset({
          title: this.f.title.value,
          lastName: this.f.lastName.value,
          firstName: this.f.firstName.value,
          email: '',
          licence: this.f.licence.value,
          password: this.f.password.value,
          confirmPassword: ''
        });
      }

      if (!this.f.password.valid) { this.uiService.openSnackBar(`Mot de passe incorrect : Minimum huit caractères, au moins une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial`, ''); }
      if (!this.f.confirmPassword.valid) { this.uiService.openSnackBar(`Mot de passe incorrect : Minimum huit caractères, au moins une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial`, ''); }
      if (!this.f.email.valid) { this.uiService.openSnackBar(`Email invalide`, ''); }
    }
    this.inactive = false;
  }

  get f() {
    return this.registerForm.controls;
  }

  private initForm(): void {
    this.registerForm = this.formBuilder.group({
      lastName: ['', Validators.required],
      firstName: [this.socialFirstname, Validators.required],
      email: [this.socialEmail, [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/)]],
      confirmPassword: ['', [Validators.required, Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/)]],
    });
  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.socialFirstname.asObservable().subscribe(firstname => {
          this.socialFirstname = firstname;
          this.cdr.detectChanges();
          this.registerForm.get('firstName').setValue(this.socialFirstname);
        })
      )
      .add(
        this.dataService.socialLastname.asObservable().subscribe(lastname => {
          this.socialLastname = lastname;
          this.cdr.detectChanges();
          this.registerForm.get('lastName').setValue(this.socialLastname);
        })
      )
      .add(
        this.dataService.socialEmail.asObservable().subscribe(email => {
          this.socialEmail = email;
          this.cdr.detectChanges();
          this.registerForm.get('email').setValue(this.socialEmail);
        })
      )
      .add(
        this.dataService.jsonResauxSocial.asObservable().subscribe(userSocialInfo => {
          this.userSocialInfo = userSocialInfo;
          this.cdr.detectChanges();
          const userInfos = JSON.parse(JSON.stringify(this.userSocialInfo));
        })
      );
  }

}


